// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { NotificationsContext } from 'Contexts/UserNotificationsContext';

export default function useNotifications() {
  return useContext(NotificationsContext);
}
